import {AdvancedMarker, Pin, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";
import {useEffect} from "react";

const NetworkMarker = ({marker, isSelected, onClick}) => {
    const [markerRef, advancedMarker] = useAdvancedMarkerRef();

    useEffect(() => {
        if (!advancedMarker) return;

        const el = advancedMarker.content;
        if (!el) return;

        if (isSelected) {
            el.classList.add("animate-bounce");
        } else {
            el.classList.remove("animate-bounce");
        }
    }, [advancedMarker, isSelected]);

    return (
        <AdvancedMarker
            ref={markerRef}
            position={{lat: marker.lat, lng: marker.lng}}
            onClick={onClick}
        >
            {marker.icon && (
                <img src={marker.icon} alt={marker.type} className="w-15 h-15 object-contain"/>
            )}
        </AdvancedMarker>
    );
};

export default NetworkMarker;
